import { BrokerId, ErrorCode } from '@trucksmarter/shared';

export interface ErrorResponse {
  message?: string;
  displayMessage?: string;
  code?: ErrorCode;
  status?: number;
  broker?: BrokerId;
}

const ERROR_RESPONSE_KEYS = [
  'message',
  'displayMessage',
  'code',
  'status',
  'broker',
] satisfies (keyof ErrorResponse)[];

export function isErrorResponse(error: unknown): error is ErrorResponse {
  return (
    error !== null &&
    typeof error === 'object' &&
    ERROR_RESPONSE_KEYS.some((key) => key in error)
  );
}

export function getErrorDisplayMessageOrDefault(
  error: unknown,
  defaultMessage: string = "Something went wrong. We're looking into it!",
): string {
  if (isErrorResponse(error) && typeof error.displayMessage === 'string') {
    return error.displayMessage;
  }

  return defaultMessage;
}

export function isAbortError(
  error: unknown,
): error is DOMException & { name: 'AbortError' } {
  return error instanceof DOMException && error.name === 'AbortError';
}
